export default __webpack_public_path__ + "static/media/info-icon.54ba1057.svg";